export function getScratchHost() {
  if(['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    return 'http://localhost:8601'
  } else if(window.location.host === '101.43.192.193:8904') {
    return 'http://101.43.192.193:8905'
  } else if(window.location.host === 'scratch.codingle.com'){
    return 'https://scratchwork.codingle.com'
  }
}